import { Map, List } from 'immutable';
import { createSelector } from 'reselect';

import { UserRoleToPermissions } from '../../enums/user-permissions';

const selectAuth = (state) => state.get('auth');

const makeSelectLoading = () => createSelector(selectAuth, (state) => state.get('loading'));

const makeSelectError = () => createSelector(selectAuth, (state) => state.get('error'));

const makeSelectIsAuthenticated = () =>
  createSelector(selectAuth, (state) => state.get('isAuthenticated'));

const makeSelectAccessToken = () => createSelector(selectAuth, (state) => state.get('accessToken'));

const makeSelectExpiresAt = () => createSelector(selectAuth, (state) => state.get('expiresAt'));

const makeSelectMetadata = () =>
  createSelector(selectAuth, (state) =>
    state.getIn(['tokenPayload', `${window._env_.JWT_DATA_PREFIX}/app_metadata`], Map()),
  );

const makeSelectEmail = () =>
  createSelector(selectAuth, (state) =>
    state.getIn(['tokenPayload', `${window._env_.JWT_DATA_PREFIX}/email`]),
  );

const makeSelectUserType = () =>
  createSelector(makeSelectMetadata(), (metadata) => metadata.get('userType'));

const makeSelectEntityId = () =>
  createSelector(makeSelectMetadata(), (metadata) => metadata.get('entityId'));

const makeSelectUserRoles = () =>
  createSelector(makeSelectMetadata(), (metadata) => metadata.get('roles', []));

const makeSelectFeatures = () =>
  createSelector(makeSelectMetadata(), (metadata) => metadata.get('features', []));

const makeSelectUserPermissions = () =>
  createSelector(makeSelectUserRoles(), (roles) =>
    roles.reduce(
      (acc, role) => (UserRoleToPermissions[role] ? acc.concat(UserRoleToPermissions[role]) : acc),
      List(),
    ),
  );

const makeSelectMasquerade = () =>
  createSelector(selectAuth, (state) => state.getIn(['tokenPayload', 'masquerade'], false));

const makeSelectMasqueradeScope = () =>
  createSelector(selectAuth, (state) => state.getIn(['tokenPayload', 'scope'], false));

const makeSelectRefreshing = () => createSelector(selectAuth, (state) => state.get('refreshing'));

const makeSelectIntegrationAuthorizationUrl = () =>
  createSelector(selectAuth, (state) => state.getIn(['integrationAuthorization', 'url'], ''));

const makeSelectIntegrationAuthorizationUrlLoading = () =>
  createSelector(selectAuth, (state) =>
    state.getIn(['integrationAuthorization', 'network', 'loading'], false),
  );

const makeSelectIntegrationAuthorizationUrlError = () =>
  createSelector(selectAuth, (state) =>
    state.getIn(['integrationAuthorization', 'network', 'error'], false),
  );

const makeSelectRouter = (state) => state.get('router');

const makeSelectLastPosition = () =>
  createSelector(makeSelectRouter, (state) => state.getIn(['location', 'state', 'from']));

export {
  makeSelectLastPosition,
  selectAuth,
  makeSelectEmail,
  makeSelectUserType,
  makeSelectUserRoles,
  makeSelectExpiresAt,
  makeSelectMasquerade,
  makeSelectRefreshing,
  makeSelectAccessToken,
  makeSelectEntityId,
  makeSelectIsAuthenticated,
  makeSelectUserPermissions,
  makeSelectIntegrationAuthorizationUrl,
  makeSelectIntegrationAuthorizationUrlLoading,
  makeSelectIntegrationAuthorizationUrlError,
  makeSelectLoading,
  makeSelectError,
  makeSelectFeatures,
  makeSelectMasqueradeScope,
};
